import {Switch, Route, useRouteMatch} from 'react-router-dom';
import PromoCodes from './Main';
import Create from './Create';
import Edit from './Edit';

export default () => {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route exact path={path}><PromoCodes /></Route>
            <Route path={`${path}/:discountCodeId/edit`}><Edit /></Route>
            <Route exact path={`${path}/create`}><Create /></Route>
        </Switch>
    )
}
